import { c as _c } from "react/compiler-runtime";
import { getCountryFromCode } from '@onefootprint/core';
import NavigationHeader from '@/idv2/features/collect-document/components/navigation-header';
import type { IdDocImageSide } from '@/idv2/features/collect-document/types';
import ErrorComponent from '../../../components/error';
import FadeInContainer from '../../../components/fade-in-container';
import IdDocPhotoButtons from '../../../components/id-doc-photo-buttons';
import type { ReceivedImagePayload } from '../../../types';
import { isSelfie } from '../../../utils/capture';
import useDocName from '../../hooks/use-doc-name';
import { useIdDocMachine } from '../machine-provider';
type CaptureRetryPromptProps = {
  imageType: `${IdDocImageSide}`;
  onComplete: (payload: ReceivedImagePayload) => void;
};
const CaptureRetryPrompt = t0 => {
  const $ = _c(37);
  const {
    imageType,
    onComplete
  } = t0;
  const [state, dispatch] = useIdDocMachine();
  const {
    errors,
    hasBadConnectivity,
    idDoc,
    requirement,
    allowPdf
  } = state.context;
  const docType = idDoc.type;
  const docCountry = idDoc.country;
  let t1;
  if ($[0] !== docType || $[1] !== imageType) {
    t1 = {
      docType,
      imageType
    };
    $[0] = docType;
    $[1] = imageType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    getDocName,
    getSideName
  } = useDocName(t1);
  if (!docType || !docCountry) {
    return null;
  }
  let t2;
  if ($[3] !== getDocName) {
    t2 = getDocName();
    $[3] = getDocName;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const docName = t2;
  let t3;
  if ($[5] !== getSideName) {
    t3 = getSideName();
    $[5] = getSideName;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const sideName = t3;
  let t4;
  if ($[7] !== docCountry) {
    t4 = getCountryFromCode(docCountry)?.label || docCountry;
    $[7] = docCountry;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const countryName = t4;
  let t5;
  if ($[9] !== imageType) {
    t5 = isSelfie(imageType);
    $[9] = imageType;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const hideUploadButton = t5;
  const hideUpload = hideUploadButton || requirement.uploadSettings === "capture_only_on_mobile" || requirement.uploadSettings === "require_mobile_capture";
  let t6;
  if ($[11] !== dispatch || $[12] !== imageType) {
    t6 = isSelfie(imageType) ? undefined : {
      variant: "back",
      onBack: () => dispatch({
        type: "navigatedToCountryDoc"
      })
    };
    $[11] = dispatch;
    $[12] = imageType;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <NavigationHeader position="floating" leftButton={t6} />;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== errors) {
    t8 = errors || [];
    $[16] = errors;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== countryName || $[19] !== docName || $[20] !== sideName || $[21] !== t8) {
    t9 = <ErrorComponent docName={docName} sideName={sideName} errors={t8} countryName={countryName} />;
    $[18] = countryName;
    $[19] = docName;
    $[20] = sideName;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== dispatch) {
    t10 = () => dispatch({
      type: "startImageCapture"
    });
    $[23] = dispatch;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== allowPdf || $[26] !== hasBadConnectivity || $[27] !== hideUpload || $[28] !== onComplete || $[29] !== t10) {
    t11 = <IdDocPhotoButtons onComplete={onComplete} hideUploadButton={hideUpload} onTakePhoto={t10} hasBadConnectivity={hasBadConnectivity} allowPdf={allowPdf} />;
    $[25] = allowPdf;
    $[26] = hasBadConnectivity;
    $[27] = hideUpload;
    $[28] = onComplete;
    $[29] = t10;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t11 || $[32] !== t9) {
    t12 = <div className="h-full flex flex-col gap-6 items-center justify-center">{t9}{t11}</div>;
    $[31] = t11;
    $[32] = t9;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t12 || $[35] !== t7) {
    t13 = <FadeInContainer>{t7}{t12}</FadeInContainer>;
    $[34] = t12;
    $[35] = t7;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  return t13;
};
export default CaptureRetryPrompt;